export const VIDEOS = [
  {
    slug: "man-man-takes-the-field",
    name: "Man-Man Takes the Field",
    desc: "Captain #76 steps up with a message about taking charge of his health.",
    src: "/videos/man-man.mp4",
    poster: "/videos/man-man-poster.jpg",
    color: "#1B365D",
    testid: "video-man-man",
  },
  {
    slug: "lil-momma-cheer-dance",
    name: "Lil Momma's Cheer Dance",
    desc: "Pom-poms up! Lil Momma shows what believing in yourself looks like.",
    src: "/videos/lil-momma-cheer.mp4",
    poster: "/videos/lil-momma-cheer-poster.jpg",
    color: "#D92B38",
    testid: "video-lil-momma",
  },
  {
    slug: "spooky-halloween-surprise",
    name: "A Spooky Halloween Surprise",
    desc: "The cousins get into costume for their Spooky Halloween Adventure.",
    src: "/videos/cousins-together.mp4",
    poster: "/videos/cousins-together-poster.jpg",
    color: "#E8761A",
    testid: "video-cousins",
  },
];
